<template>
  <Content class="goodsBox">
    <Button type="primary" style="margin-bottom: 24px" @click="show()">
      添加
    </Button>
    <Form id="searchForm" :model="formItem" :label-width="80" inline>
      <FormItem label="角色名称">
        <Input v-model="formItem.key" placeholder="模糊搜索" clearable />
      </FormItem>
      <FormItem :label-width="20">
        <Button type="primary" @click="search">查询</Button>
        <Button style="margin-left: 8px" @click="clear">重置</Button>
      </FormItem>
    </Form>
    <Table
      :columns="columns"
      :data="tableData"
      :height="tablesHeight"
      border
    ></Table>
    <Page
      class="table_page_css"
      v-show="total"
      :total="total"
      :current="searchInfo.pageNo"
      :page-size="searchInfo.pageSize"
      :page-size-opts="pageSizeOpts"
      @on-change="pageNoChange"
      @on-page-size-change="pageSizeChange"
      show-sizer
      show-elevator
      show-total
    />
    <AddUpdate @reload="getList" ref="AddUpdate"></AddUpdate>
    <RolesPermits @reload="getList" ref="RolesPermits"></RolesPermits>
    <RolesArea @reload="getList" ref="RolesArea"></RolesArea>
  </Content>
</template>
<script>
import { rolesPage, rolesDel } from '@/api/role'
import AddUpdate from './RolesAddUpdate'
import RolesPermits from './RolesPermits'
import RolesArea from './RolesArea'
export default {
  name: 'Roles',
  components: {
    AddUpdate,
    RolesPermits,
    RolesArea,
  },
  data() {
    return {
      columns: [
        {
          type: 'index',
          width: 60,
          align: 'center',
        },
        {
          title: '角色名称',
          key: 'role_name',  // 修改为下划线形式
        },
        {
          title: '角色描述',
          key: 'role_desc',  // 修改为下划线形式
        },
        {
          title: '操作',
          key: 'action',
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h(
                'Button',
                {
                  props: {
                    type: 'primary',
                    size: 'small',
                  },
                  style: {
                    marginRight: '5px',
                  },
                  on: {
                    click: () => {
                      this.show(params.row)
                    },
                  },
                },
                '编辑',
              ),
              h(
                'Poptip',
                {
                  props: {
                    confirm: true,
                    transfer: true,
                    title: '您确认删除这条内容吗？',
                  },
                  on: {
                    'on-ok': () => {
                      this.remove(params.row._id)
                    },
                  },
                },
                [
                  h(
                    'Button',
                    {
                      props: {
                        type: 'error',
                        size: 'small',
                      },
                      style: {
                        marginRight: '5px',
                      },
                    },
                    '删除',
                  ),
                ],
              ),
              h(
                'Button',
                {
                  props: {
                    type: 'warning',
                    size: 'small',
                  },
                  on: {
                    click: () => {
                      this.getPermit(params.row)
                    },
                  },
                },
                '分配权限',
              ),
              h(
                'Button',
                {
                  props: {
                    type: 'warning',
                    size: 'small',
                  },
                  on: {
                    click: () => {
                      this.getArea(params.row)
                    },
                  },
                },
                '分配区域',
              ),
            ])
          },
        },
      ],
      tableData: [],
      total: 0,
      searchInfo: {
        pageNo: 1,
        pageSize: 5,
      },
      pageSizeOpts: [1, 2, 5, 10],
      formItem: {
        key: '',
      },
      tablesHeight: 0,
    }
  },
  methods: {
    // 设置表格高度的函数
    setTablesHeight() {
      let aH = 0 
      let oA = document.getElementById('app') 
      let oH = oA.clientHeight || oA.offsetHeight 
      let sA = document.getElementById('searchForm') 
      let sH = sA.clientHeight || sA.offsetHeight 
      aH = oH - sH - 265 
      this.tablesHeight = aH 
    },

    // 获取列表数据的函数
    getList() {
      rolesPage(this.searchInfo) 
        .then((res) => {
          if (res.data.code === 200) {
            const data = res.data 
            this.tableData = data.data 
            
            // 如果后端返回的是驼峰形式，需要在前端转换为下划线形式
            if (this.tableData && this.tableData.length > 0) {
              this.tableData.forEach(item => {
                if (item.roleName !== undefined && item.role_name === undefined) {
                  item.role_name = item.roleName;
                }
                if (item.roleDesc !== undefined && item.role_desc === undefined) {
                  item.role_desc = item.roleDesc;
                }
              });
            }
            
            this.total = data.total 
          } else {
            this.$Message.error(res.data.msg) 
          }
        })
        .catch((err) => {
          this.$Message.error(err) 
        })
    },

    // 搜索函数
    search() {
      this.searchInfo = {
        // 更新搜索信息
        key: this.formItem.key, // 搜索关键字
        pageNo: 1, // 重置页码为1
        pageSize: this.searchInfo.pageSize, // 保持当前页大小不变
      }
      this.getList() // 调用getList函数重新获取数据
    },

    // 清除搜索条件的函数
    clear() {
      this.formItem = {
        // 重置表单数据
        key: '', // 清空搜索关键字
      }
      this.searchInfo = {
        // 重置搜索信息
        pageNo: 1, // 重置页码为1
        pageSize: 5, // 重置页大小为5
      }
      this.getList() // 调用getList函数重新获取数据
    },

    // 显示添加或更新角色的模态框
    show(params) {
      if (params) {
        // 如果params存在，表示更新操作
        this.$refs.AddUpdate.init(params) // 调用AddUpdate组件的init方法，传入参数
      } else {
        // 如果params不存在，表示添加操作
        this.$refs.AddUpdate.init() // 调用AddUpdate组件的init方法，不传参数
      }
    },

    // 获取角色权限的函数
    getPermit(roleId) {
      this.$refs.RolesPermits.init(roleId) // 调用RolesPermits组件的init方法，传入角色ID
    },

    // 获取角色区域的函数
    getArea(roleId) {
      this.$refs.RolesArea.init(roleId) // 调用RolesArea组件的init方法，传入角色ID
    },

    // 删除角色的函数
    remove(_id) {
      rolesDel({ _id: _id }) // 调用rolesDel API删除角色，传入角色ID
        .then((res) => {
          // 处理成功的响应
          if (res.data.code === 200) {
            // 如果响应码为200，表示成功
            this.$Message.success('删除成功') // 显示成功消息
            this.getList() // 调用getList函数重新获取数据
          } else {
            this.$Message.error(res.data.msg) // 如果响应码不是200，显示错误消息
          }
        })
        .catch((err) => {
          // 处理错误的响应
          this.$Message.error(err) // 显示错误消息
        })
    },

    // 页码改变的函数
    pageNoChange(current) {
      this.searchInfo.pageNo = current // 更新当前页码
      this.getList() // 调用getList函数重新获取数据
    },

    // 页大小改变的函数
    pageSizeChange(val) {
      this.searchInfo.pageNo = 1 // 重置页码为1
      this.searchInfo.pageSize = val // 更新页大小
      this.getList() // 调用getList函数重新获取数据
    },
  },
  mounted() {
    this.getList()
    setTimeout(() => {
      this.setTablesHeight()
    }, 50)
    window.onresize = () => {
      this.setTablesHeight()
    }
  },
}
</script>
<style lang="less" scoped>
.goodsBox {
  .ivu-form-inline .ivu-form-item {
    width: 267px;
  }
}
</style>
